<script lang="ts" setup>
import vuIcon from '@ds/vuekit/src/components/vu-icon.vue';
import type { HomePageFeature } from '../../models/homepage';
import useI18NAsync from '~/composables/i18nAsync';
import { NlsHomepage } from '~/typings/nls/homepage';
const i18nSuspense = useI18NAsync('homepage');

const props = defineProps<{
  features: HomePageFeature[];
}>();
const emit = defineEmits(['featureClicked']);
</script>
<template>
  <div
    class="features grid grid--sm grid-4-columns--sm grid-2-columns--xs grid-gap-10px grid-gap-5px--sm"
  >
    <div
      v-for="feature in props.features"
      :key="`feature-${feature.title}`"
      class="feature flex flex-row align-items-center flex-columns--xs justify-center--xs grid-gap-5px slide-up-enter--sm slide-right-enter"
      @click.stop="emit('featureClicked', feature)"
    >
      <div :id="`${feature.icon}-icon`" class="relative">
        <vu-icon
          icon="status-ok"
          color="green-icon"
          class="absolute-icon flex-important align-items-center justify-center"
        />
        <vu-icon :icon="feature.icon" color="white--text" class="before-icon" />
      </div>
      <span class="text"><i18nSuspense :ikey="feature.title as keyof NlsHomepage" /></span>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@use '/assets/scss/variables' as variables;

.absolute-icon {
  position: absolute;
  left: -7px;
  top: 0;
  width: 17px;
  height: 17px;
  color: var(--green-1);
  border-radius: 50px;
  font-size: 15px;
  background-color: white;
  border: 2px solid var(--green-1);

  @include variables.for-mid {
    font-size: 10px;
    width: 10px;
    height: 10px;
    left: -2px;
  }
}

.before-icon {
  font-size: 28px;

  @include variables.for-mid {
    font-size: 20px;
  }
}

.features {
  font-size: 18px;

  @include variables.for-mid {
    font-size: 14px;
  }

  @include variables.for-sm {
    margin: auto;
    font-size: 12px;
  }
}

@include variables.for-sm {
  .slide-up-enter--sm:nth-child(2) {
    animation-delay: 50ms;
  }
  .slide-up-enter--sm:nth-child(3) {
    animation-delay: 100ms;
  }
  .slide-up-enter--sm:nth-child(4) {
    animation-delay: 150ms;
  }
}
</style>
